import { render, staticRenderFns } from "./returns.vue?vue&type=template&id=12726d96&scoped=true&"
import script from "./returns.vue?vue&type=script&lang=js&"
export * from "./returns.vue?vue&type=script&lang=js&"
import style0 from "./returns.vue?vue&type=style&index=0&id=12726d96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12726d96",
  null
  
)

export default component.exports